<div *ngFor="let r of resources" [style.paddingLeft]="getPadding()">
  <ion-item class="ressource-line">
    <ion-icon [icon]="getMainIcon(r.resource)" slot="start" size="large" class="res-main-icon"></ion-icon>
    <span>{{ r.resource.Name || r.resource.VehicleCode || unit.Name }}</span>
    <ion-icon [name]="getSecondaryIcon(r)" class="secondary-icon"></ion-icon>
  </ion-item>
  <app-unit-resources *ngIf="r.children" [unit]="unit" [resources]="r.children" [level]="level + 1"></app-unit-resources>
</div>
